export enum ConnectionStatus {
  'NOT_INVITED' = 'NOT_INVITED',
  'NOT_CONNECTED' = 'NOT_CONNECTED',
  'CONNECTED' = 'CONNECTED',
}

export enum ProviderType {
  'libreview' = 'libreview',
  'dexcom' = 'dexcom',
  'libreview-csv' = 'libreview-csv',
  'dexcom-csv' = 'dexcom-csv',
  'fslibre-json' = 'fslibre-json',
  'virtual' = 'virtual',
  'libre-view-api' = 'libre-view-api',
  'diaexpert' = 'diaexpert',
  'roche' = 'roche',
}

export enum SensorTypeEnum {
  'FreeStyle Libre 3' = 'FreeStyle Libre 3',
  'FreeStyle Libre 2' = 'FreeStyle Libre 2',
  'FreeStyle Libre' = 'FreeStyle Libre',
  'Dexcom G7' = 'Dexcom G7',
  'DiaExpert CGM' = 'DiaExpert CGM',
  'Accu-Chek CGM' = 'Accu-Chek CGM',
  'virtual' = 'virtual',
}

export enum GlucoseValueType {
  'AUTOMATIC' = 'AUTOMATIC',
  'MANUAL' = 'MANUAL',
  'BLOOD_TEST' = 'BLOOD_TEST',
}

export enum ProviderName {
  libreview = 'libreview',
  libreviewApi = 'libre-view-api',
  dexcom = 'dexcom',
  dexcomRct = 'dexcom-rct',
  dexcomRtSandbox = 'dexcom-rt-sandbox',
  dexcomStaging = 'dexcom-staging',
  dexcomK8s = 'dexcom-k8s',
  virtual = 'virtual',
  diaexpert = 'diaexpert',
  roche = 'roche',
}
